import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=86de91de&"
import script from "./MobileApp.vue?vue&type=script&lang=js&"
export * from "./MobileApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports